import { cilArrowCircleBottom, cilArrowCircleTop, cilMenu, cilMoon, cilSun } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CAvatar, CContainer, CHeader, CHeaderNav, CHeaderToggler } from '@coreui/react-pro'
import React, { useContext, useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { useDispatch, useSelector } from 'react-redux'
import { THEME } from 'src/actions/actionType'
import { logoSmall } from 'src/assets/brand/logo-small'
import { logoSmallDark } from 'src/assets/brand/logo-small-dark'
import { DARK, LIGHT } from 'src/constants/Constants'
import { AuthContext } from 'src/context/AuthContext'
import { isDarkTheme } from 'src/selectors/ThemeSelector'
import { AppHeaderDropdown, AppHeaderLanguages } from './header/index'
import { AppBreadcrumb } from './index'

const AppHeader = () => {
  const dispatch = useDispatch()
  const isDark = useSelector(isDarkTheme)
  const { isShowMobile } = useContext(AuthContext)
  const [isQa, setIsQa] = useState(false)

  const handleScroll = (action) => {
    window.scrollTo({
      top: action === 'top' ? 0 : document.body.scrollHeight,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    if (process.env.REACT_APP_SERVER_URL && process.env.REACT_APP_SERVER_URL?.includes('qa')) {
      document.title = '3DM Bridge QA'
      setIsQa(true)
    } else {
      document.title = '3DM Bridge'
    }
    return () => {
      document.title = '3DM Bridge'
    }
  }, [])

  isDark ? document.body.classList.add('dark-theme') : document.body.classList.remove('dark-theme')
  const sidebarShow = useSelector((state) => state.sidebar.sidebarShow)

  return (
    <CHeader position="sticky" id="header" className="mb-0 mb-md-4">
      <CContainer fluid>
        {!!isShowMobile ? (
          <>
            <BrowserView>
              <CHeaderToggler
                className="ps-1"
                onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
              >
                <CIcon icon={cilMenu} size="lg" />
              </CHeaderToggler>
            </BrowserView>
            <MobileView>
              <CIcon
                className="px-1 me-2 mb-1"
                icon={isDark ? logoSmallDark : logoSmall}
                height={40}
                width={80}
              />
            </MobileView>
            <AppBreadcrumb />
          </>
        ) : (
          <CHeaderToggler
            className="ps-1"
            onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
          >
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
        )}
        <CHeaderNav className="ms-auto me-0">
          {isQa && (
            <CAvatar color="dm3red" size="sm" textColor="white" className="me-2">
              QA
            </CAvatar>
          )}
          <AppHeaderLanguages />
        </CHeaderNav>
        <BrowserView>
          <CHeaderToggler onClick={() => dispatch({ type: THEME, theme: isDark ? LIGHT : DARK })}>
            {isDark ? <CIcon icon={cilMoon} size="lg" /> : <CIcon icon={cilSun} size="lg" />}
          </CHeaderToggler>
        </BrowserView>
        <CHeaderToggler onClick={() => handleScroll('top')}>
          <CIcon icon={cilArrowCircleTop} size="lg" />
        </CHeaderToggler>
        <CHeaderToggler onClick={() => handleScroll('bottom')}>
          <CIcon icon={cilArrowCircleBottom} size="lg" />
        </CHeaderToggler>
        <CHeaderNav>
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}
export default AppHeader
